import {
  JointPersonalAccountType,
  RetirementPersonalAccountType,
} from '@/types/schema';

/** JOINT ACCOUNT TYPE TYPES */
export const JOINT_ACCOUNT_TYPE_DISPLAY_NAMES: Record<
  JointPersonalAccountType,
  string
> = {
  [JointPersonalAccountType.CommunityProperty]: 'Community property',
  [JointPersonalAccountType.CommunityPropertyWithRightOfSurvivorship]:
    'Community property with right of survivorship',
  [JointPersonalAccountType.JointTenants]: 'Joint tenants',
  [JointPersonalAccountType.JointTenantsWithRightOfSurvivorship]:
    'Joint tenants with right of survivorship',
  [JointPersonalAccountType.TenantsByEntirety]: 'Tenants by entirety',
  [JointPersonalAccountType.TenantsInCommon]: 'Tenants in common',
};

/** JOINT ACCOUNT TYPE TYPES (with the "with" in parentheses) */
export const JOINT_ACCOUNT_TYPE_DISPLAY_NAMES_SHORT: Record<
  JointPersonalAccountType,
  string
> = {
  ...JOINT_ACCOUNT_TYPE_DISPLAY_NAMES,
  [JointPersonalAccountType.CommunityPropertyWithRightOfSurvivorship]:
    'Community property (right of survivorship)',
  [JointPersonalAccountType.JointTenantsWithRightOfSurvivorship]:
    'Joint tenants (right of survivorship)',
};

/** RETIREMENT ACCOUNT TYPES */
export const RETIREMENT_ACCOUNT_TYPE_DISPLAY_NAMES: Record<
  RetirementPersonalAccountType,
  string
> = {
  [RetirementPersonalAccountType.Ira]: 'IRA',
  [RetirementPersonalAccountType.InheritedIra]: 'Inherited IRA',
  [RetirementPersonalAccountType.RothIra]: 'Roth IRA',
  [RetirementPersonalAccountType.InheritedRothIra]: 'Inherited Roth IRA',
  [RetirementPersonalAccountType.Type_401K]: '401k',
  [RetirementPersonalAccountType.DefinedBenefitPlan]:
    'Defined benefit plan/pension',
  [RetirementPersonalAccountType.Other]: 'Other',
};

/** RETIREMENT ACCOUNT TYPE TYPES (with the "with" in parentheses) */
export const RETIREMENT_ACCOUNT_TYPE_DISPLAY_NAMES_SHORT: Record<
  RetirementPersonalAccountType,
  string
> = {
  // no changes as of 2025-03-18
  ...RETIREMENT_ACCOUNT_TYPE_DISPLAY_NAMES,
};
